module.exports = __webpack_public_path__ + "img/smartcities.bbe7f514.png";